import * as React from "react";
import ActionDropdown from "views/components/common/ActionDropdown";
import IconButton from "components/common/IconButton";
const QueryActionDropdown = ({ children }) => /* @__PURE__ */ React.createElement(
  ActionDropdown,
  {
    element: /* @__PURE__ */ React.createElement(IconButton, { name: "arrow_drop_down", "data-testid": "query-action-dropdown", title: "Page Actions", showTooltip: false })
  },
  children
);
export default QueryActionDropdown;
